import React from 'react'

const FileUploader = ({onFileSelectSuccess, onFileSelectError, accept}) => {

    const handleFileInput = (e) => {          
      const file = e.target.files?.[0];

      if (!file) {
        return;
      }

      if (file.size > (8 * 1024 * 1024)) {
         onFileSelectError({ error: "Arquivo não dever maior que 8 Mb" });
         e.target.value = '';
      }
      else {
          onFileSelectSuccess(file);
          e.target.value = '';
      }
    };

    return (
        <div className="file-uploader">            
            <input type="file" accept={accept} onChange={handleFileInput} />
        </div>
    )
}

export default FileUploader;
